import { TextInput as MantineTextInput, type TextInputProps as MantineTextInputProps } from '@mantine/core'
import { IconAlphabetLatin } from '@tabler/icons-react'
import { type FC } from 'react'

export interface TextInputProps extends MantineTextInputProps {}

export const TextInput: FC<TextInputProps> = (mantineTextInputProps) => (
  <MantineTextInput
    icon={<IconAlphabetLatin size={18} />}
    {...mantineTextInputProps}
  />
)
